'use client';

import { c as _c } from "react/compiler-runtime";
import { InfoCircle } from '@byway/icons';
import { useTranslations } from 'next-intl';
import { Button, DialogTrigger } from 'react-aria-components';
import { Link } from '~/components/Link';
import { Popover } from '~/components/Popover';
import styles from '../TripOverviewPage.module.css';
const carbonFormatter = new Intl.NumberFormat('en-GB', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
});
type EmissionsBadgeProps = {
  savingsPercentForBadge: number;
  totalCarbonFootprint: number;
  formattedCarbonSavings: number | undefined;
  hasUsageComparisons: boolean;
  journeyCarbonUsage?: {
    carEquivalent: number;
    flightEquivalent: number;
  };
};
export function EmissionsBadge(t0) {
  const $ = _c(34);
  const {
    savingsPercentForBadge,
    totalCarbonFootprint,
    formattedCarbonSavings,
    hasUsageComparisons,
    journeyCarbonUsage
  } = t0;
  const t = useTranslations("journey");
  const commonT = useTranslations("common");
  let t1;
  if ($[0] !== t) {
    t1 = t("overview_emissions_show_comparison");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <InfoCircle decorative={true} isInline={true} size="small" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== savingsPercentForBadge) {
    t3 = <span className={styles.emissionsBadge}>{savingsPercentForBadge}% emissions{t2}</span>;
    $[3] = savingsPercentForBadge;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t3) {
    t4 = <Button data-ua-click="carbon-savings-button" className={styles.emissionsBadgeButton} aria-label={t1}>{t3}</Button>;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("carbon_heading");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("carbon_heading");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <h3 className={styles.emissionsPopoverHeading}>{t6}</h3>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== formattedCarbonSavings || $[15] !== hasUsageComparisons || $[16] !== journeyCarbonUsage || $[17] !== t || $[18] !== totalCarbonFootprint) {
    t8 = hasUsageComparisons && typeof formattedCarbonSavings === "number" ? <><ul className={styles.emissionsPopoverList}><li className={styles.emissionsPopoverItem}><span className={styles.emissionsPopoverLabelStrong}>{t("carbon_this_trip")}</span><span className={styles.emissionsPopoverValueStrong}>{carbonFormatter.format(totalCarbonFootprint)} kg CO<sub>2</sub></span></li><li className={styles.emissionsPopoverItem}><span>{t("carbon_driving")}</span><span>{carbonFormatter.format(journeyCarbonUsage.carEquivalent)} kg CO<sub>2</sub></span></li><li className={styles.emissionsPopoverItem}><span>{t("carbon_flying")}</span><span>{carbonFormatter.format(journeyCarbonUsage.flightEquivalent)} kg CO<sub>2</sub></span></li></ul><p className={styles.emissionsPopoverBody}><strong>{t(formattedCarbonSavings < 0 ? "carbon_comparison_fewer" : "carbon_comparison_more", {
            percent: Math.abs(formattedCarbonSavings)
          })}</strong>{" "}{t("carbon_note")}</p></> : <p className={styles.emissionsPopoverBody}>{t("carbon_note")}</p>;
    $[14] = formattedCarbonSavings;
    $[15] = hasUsageComparisons;
    $[16] = journeyCarbonUsage;
    $[17] = t;
    $[18] = totalCarbonFootprint;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== commonT) {
    t9 = commonT("learn_more");
    $[20] = commonT;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t9) {
    t10 = <Link hasUnderline={true} href="https://www.byway.travel/blog/new-feature-alert-carbon-labelling-for-every-trip">{t9}</Link>;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t7 || $[26] !== t8) {
    t11 = <div className={styles.emissionsPopoverContent}>{t7}{t8}{t10}</div>;
    $[24] = t10;
    $[25] = t7;
    $[26] = t8;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t11 || $[29] !== t5) {
    t12 = <Popover hasArrow={true} ariaLabel={t5}>{t11}</Popover>;
    $[28] = t11;
    $[29] = t5;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t12 || $[32] !== t4) {
    t13 = <DialogTrigger>{t4}{t12}</DialogTrigger>;
    $[31] = t12;
    $[32] = t4;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  return t13;
}